/* /assets/recommended-products.js */

(function() {
  // Helper to get theme strings with fallback
  function getThemeString(key, fallback) {
    return window.theme && window.theme.strings && window.theme.strings[key] || fallback;
  }

  // Helper function to update ATC button state
  function updateAtcState(card, isAvailable) {
    var atcBtn = card.querySelector('[data-add-to-cart]');
    var atcText = card.querySelector('.rec-card__atc-text');
    if (atcBtn && atcText) {
      atcBtn.disabled = !isAvailable;
      atcText.textContent = isAvailable 
        ? getThemeString('addToCart', 'Add to Cart')
        : getThemeString('soldOut', 'Sold Out');
    }
  }

  // Fetch and render recommendations from Shopify API on page load
  function initRecommendations() {
    var wrapper = document.querySelector('[data-recommended-products]');
    if (!wrapper) return;
    
    var grid = wrapper.querySelector('[data-recommended-grid]');
    if (!grid) return;
    
    var productId = grid.dataset.productId;
    var useApi = grid.dataset.useApi === 'true';
    
    // Skip if no product ID or API disabled
    if (!productId || !useApi) return;
    
    // Get exclusion lists
    var cartProductIds = (wrapper.dataset.cartProductIds || '').split(',').filter(Boolean);
    var upsellProductIds = (wrapper.dataset.upsellProductIds || '').split(',').filter(Boolean);
    
    // Fetch recommendations from Shopify API
    var recommendationsUrl = '/recommendations/products.json?product_id=' + productId + '&limit=20&intent=related';
    
    fetch(recommendationsUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Recommendations fetch failed');
        return response.json();
      })
      .then(function(data) {
        if (!data.products || data.products.length === 0) {
          console.log('No recommendations available');
          return Promise.resolve([]);
        }
        
        // Filter out excluded products (get more than 4 to allow for sibling deduplication later)
        var validProducts = [];
        var addedProductIds = [];
        
        for (var i = 0; i < data.products.length && validProducts.length < 12; i++) {
          var product = data.products[i];
          var productIdStr = String(product.id);
          
          // Skip if in cart
          if (cartProductIds.indexOf(productIdStr) !== -1) continue;
          
          // Skip if is upsell
          if (upsellProductIds.indexOf(productIdStr) !== -1) continue;
          
          // Skip if not available
          if (!product.available) continue;
          
          // Skip if already added (prevent duplicates)
          if (addedProductIds.indexOf(productIdStr) !== -1) continue;
          
          validProducts.push(product);
          addedProductIds.push(productIdStr);
        }
        
        if (validProducts.length === 0) {
          console.log('No valid recommendations after filtering');
          return Promise.resolve([]);
        }
        
        // Fetch section HTML for each valid product
        var fetchPromises = validProducts.map(function(product) {
          var sectionUrl = '/products/' + product.handle + '?section_id=recommended-product-card-api';
          return fetch(sectionUrl)
            .then(function(response) {
              if (!response.ok) return null;
              return response.text();
            })
            .then(function(html) {
              return { product: product, html: html };
            })
            .catch(function() {
              return null;
            });
        });
        
        return Promise.all(fetchPromises);
      })
      .then(function(results) {
        if (!results || results.length === 0) return;
        
        // Filter out failed fetches and empty HTML
        var validResults = results.filter(function(r) {
          return r && r.html && r.html.trim().length > 0;
        });
        
        if (validResults.length === 0) {
          console.log('No valid card HTML returned');
          return;
        }
        
        // Deduplicate: ensure no product appears in multiple cards (as main or sibling)
        // Also exclude cards with siblings that are in the cart
        var usedProductIds = [];
        var deduplicatedResults = [];
        
        for (var i = 0; i < validResults.length && deduplicatedResults.length < 4; i++) {
          var result = validResults[i];
          var mainProductId = String(result.product.id);
          
          // Parse HTML to extract sibling product IDs
          var siblingIds = [];
          var siblingMatches = result.html.match(/data-sibling-product-id="(\d+)"/g);
          if (siblingMatches) {
            siblingMatches.forEach(function(match) {
              var id = match.match(/data-sibling-product-id="(\d+)"/)[1];
              if (siblingIds.indexOf(id) === -1) {
                siblingIds.push(id);
              }
            });
          }
          
          // Check if main product is already used
          if (usedProductIds.indexOf(mainProductId) !== -1) {
            continue;
          }
          
          // Check if any sibling is already used
          var hasDuplicateSibling = siblingIds.some(function(sibId) {
            return usedProductIds.indexOf(sibId) !== -1;
          });
          
          if (hasDuplicateSibling) {
            continue;
          }
          
          // Check if any sibling is in the cart (skip entire card if so)
          var hasSiblingInCart = siblingIds.some(function(sibId) {
            return cartProductIds.indexOf(sibId) !== -1;
          });
          
          if (hasSiblingInCart) {
            continue;
          }
          
          // Add this card and mark all its product IDs as used
          deduplicatedResults.push(result);
          usedProductIds.push(mainProductId);
          siblingIds.forEach(function(sibId) {
            if (usedProductIds.indexOf(sibId) === -1) {
              usedProductIds.push(sibId);
            }
          });
        }
        
        if (deduplicatedResults.length === 0) {
          console.log('No valid card HTML after deduplication');
          return;
        }
        
        // Replace skeleton cards with API recommendations
        grid.innerHTML = deduplicatedResults.map(function(r) { return r.html; }).join('');
        
        // Fix cards where {% form %} tag didn't render properly via Section Rendering API
        grid.querySelectorAll('[data-rec-card]').forEach(function(card) {
          var actionsDiv = card.querySelector('.rec-card__actions');
          if (!actionsDiv) return;
          
          // Check if form is missing (inputs are direct children of actions div)
          var existingForm = actionsDiv.querySelector('form');
          if (!existingForm) {
            var variantInput = actionsDiv.querySelector('[data-rec-variant-input]');
            var atcButton = actionsDiv.querySelector('[data-add-to-cart]');
            if (!variantInput || !atcButton) return;
            
            // Create proper form wrapper
            var productId = card.dataset.productId;
            var form = document.createElement('form');
            form.method = 'post';
            form.action = '/cart/add';
            form.id = 'product_form_' + productId;
            form.acceptCharset = 'UTF-8';
            form.className = 'shopify-product-form';
            form.enctype = 'multipart/form-data';
            
            // Move all children into form
            while (actionsDiv.firstChild) {
              form.appendChild(actionsDiv.firstChild);
            }
            actionsDiv.appendChild(form);
          }
          
          // Remove stuck loading state from button
          var atcButton = actionsDiv.querySelector('[data-add-to-cart]');
          if (atcButton) {
            atcButton.classList.remove('is-loading');
            atcButton.removeAttribute('disabled');
          }
        });
        
        // Reinitialize Alpine for dynamically added content
        if (window.Alpine) {
          // Clean up any stale Alpine state before reinitializing 
          grid.querySelectorAll('[x-data]').forEach(function(el) {
            if (el._x_dataStack) {
              delete el._x_dataStack;
            }
            // Remove Alpine's internal cleanup markers
            el._x_ignore = false;
          });
          
          // Use nextTick to ensure DOM is ready
          window.Alpine.nextTick(function() {
            window.Alpine.initTree(grid);
          });
        }
        
        // Fallback: Add direct form submit handlers for rec cards in case Alpine fails
        grid.querySelectorAll('.rec-card__actions form').forEach(function(form) {
          // Skip if already has our handler
          if (form.dataset.recSubmitHandler) return;
          form.dataset.recSubmitHandler = 'true';
          
          form.addEventListener('submit', function(e) {
            var atcButton = form.querySelector('[data-add-to-cart]');
            var atcText = form.querySelector('.rec-card__atc-text');
            
            // Check if Alpine handled this (button would be in loading state)
            if (atcButton && atcButton.classList.contains('is-loading')) {
              return; // Let Alpine handle it
            }
            
            e.preventDefault();
            
            if (atcButton) {
              atcButton.classList.add('is-loading');
              atcButton.disabled = true;
            }
            
            var formData = new FormData(form);
            
            fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then(function(response) {
              if (!response.ok) {
                return response.json().then(function(err) { throw err; });
              }
              return response.json();
            })
            .then(function(data) {
              if (atcButton) {
                atcButton.classList.remove('is-loading');
                atcButton.classList.add('is-success');
                if (atcText) {
                  atcText.textContent = getThemeString('addedToCart', 'Added!');
                }
                
                setTimeout(function() {
                  atcButton.classList.remove('is-success');
                  atcButton.disabled = false;
                  if (atcText) {
                    atcText.textContent = getThemeString('addToCart', 'Add to Cart');
                  }
                }, 2000);
              }
              
              // Update cart count in header
              if (window.theme && window.theme.cart && typeof window.theme.cart.updateHeaderTotal === 'function') {
                window.theme.cart.updateHeaderTotal();
              }
              
              // Trigger cart update event for other components
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              
              // Open cart drawer or popdown if available
              if (window.theme && window.theme.cart) {
                if (typeof window.theme.cart.openCartDrawer === 'function') {
                  window.theme.cart.openCartDrawer();
                } else if (typeof window.theme.cart.openPopdown === 'function') {
                  window.theme.cart.openPopdown(data);
                }
              }
            })
            .catch(function(error) {
              console.error('Add to cart error:', error);
              if (atcButton) {
                atcButton.classList.remove('is-loading');
                atcButton.disabled = false;
              }
              if (atcText && error.description) {
                atcText.textContent = error.description;
                setTimeout(function() {
                  atcText.textContent = getThemeString('addToCart', 'Add to Cart');
                }, 3000);
              }
            });
          });
        });
        
        console.log('Loaded ' + deduplicatedResults.length + ' recommendations from API');
      })
      .catch(function(error) {
        console.log('Recommendations API error:', error.message);
      });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendations);
  } else {
    initRecommendations();
  }

  // Handle variant swatch clicks for recommended product cards
  document.addEventListener('click', function(e) {
    const swatchBtn = e.target.closest('[data-swatch-button]');
    if (!swatchBtn) return;
    
    const card = swatchBtn.closest('[data-rec-card]');
    if (!card) return;
    
    const variantId = swatchBtn.dataset.variantId;
    const variantPrice = swatchBtn.dataset.variantPrice;
    const variantImage = swatchBtn.dataset.variantImage;
    const variantAvailable = swatchBtn.dataset.variantAvailable === 'true';
    
    // Update selected state
    card.querySelectorAll('[data-swatch-button]').forEach(function(btn) {
      btn.classList.remove('rec-card__swatch--selected');
    });
    swatchBtn.classList.add('rec-card__swatch--selected');
    
    // Update variant input
    const variantInput = card.querySelector('[data-rec-variant-input]');
    if (variantInput) {
      variantInput.value = variantId;
    }
    
    // Update price display
    const priceEl = card.querySelector('[data-rec-price]');
    if (priceEl && variantPrice) {
      priceEl.textContent = variantPrice;
    }
    
    // Update image
    const imageEl = card.querySelector('[data-rec-image]');
    if (imageEl && variantImage) {
      imageEl.src = variantImage;
    }
    
    // Update ATC button price and availability
    const productId = card.dataset.productId;
    const variantsScript = document.querySelector('[data-rec-card-variants="' + productId + '"]');
    if (variantsScript) {
      try {
        const variants = JSON.parse(variantsScript.textContent);
        const variant = variants.find(function(v) { return v.id == variantId; });
        if (variant) {
          const atcPriceEl = card.querySelector('[data-rec-atc-price]');
          if (atcPriceEl) {
            atcPriceEl.textContent = variant.price_short;
          }
          
          // Update button state based on availability
          updateAtcState(card, variant.available);
        }
      } catch (err) {
        console.error('Error parsing variants:', err);
      }
    } else {
      // Fallback if no variants script - use data attributes
      updateAtcState(card, variantAvailable);
    }
  });
  
  // Handle sibling swatch clicks (different products as color variants)
  document.addEventListener('click', function(e) {
    const siblingBtn = e.target.closest('[data-sibling-button]');
    if (!siblingBtn) return;
    
    const card = siblingBtn.closest('[data-rec-card]');
    if (!card) return;
    
    const siblingData = {
      productId: siblingBtn.dataset.siblingProductId,
      variantId: siblingBtn.dataset.siblingVariantId,
      price: siblingBtn.dataset.siblingPrice,
      priceShort: siblingBtn.dataset.siblingPriceShort,
      image: siblingBtn.dataset.siblingImage,
      title: siblingBtn.dataset.siblingTitle,
      url: siblingBtn.dataset.siblingUrl,
      available: siblingBtn.dataset.siblingAvailable === 'true'
    };
    
    // Update selected state for all sibling buttons
    card.querySelectorAll('[data-sibling-button]').forEach(function(btn) {
      btn.classList.remove('rec-card__swatch--selected');
      btn.removeAttribute('aria-current');
    });
    siblingBtn.classList.add('rec-card__swatch--selected');
    siblingBtn.setAttribute('aria-current', 'true');
    
    // Update card product ID
    card.dataset.productId = siblingData.productId;
    
    // Update variant input
    const variantInput = card.querySelector('[data-rec-variant-input]');
    if (variantInput) {
      variantInput.value = siblingData.variantId;
    }
    
    // Update image
    const imageEl = card.querySelector('[data-rec-image]');
    if (imageEl && siblingData.image) {
      imageEl.src = siblingData.image;
    }
    
    // Update title
    const titleEl = card.querySelector('.rec-card__title');
    if (titleEl) {
      titleEl.textContent = siblingData.title;
      titleEl.href = siblingData.url;
    }
    
    // Update image link
    const imageLink = card.querySelector('.rec-card__image-link');
    if (imageLink) {
      imageLink.href = siblingData.url;
    }
    
    // Update price display
    const priceEl = card.querySelector('[data-rec-price]');
    if (priceEl) {
      priceEl.textContent = siblingData.price;
    }
    
    // Update ATC button price
    const atcPriceEl = card.querySelector('[data-rec-atc-price]');
    if (atcPriceEl) {
      atcPriceEl.textContent = siblingData.priceShort;
    }
    
    // Update button state based on availability
    updateAtcState(card, siblingData.available);
  });
  
  // Mobile "Show more suggestions" toggle
  document.addEventListener('click', function(e) {
    const showMoreBtn = e.target.closest('[data-recommended-show-more]');
    if (!showMoreBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const wrapper = showMoreBtn.closest('[data-recommended-products]');
    if (!wrapper) return;
    
    const container = wrapper.querySelector('[data-recommended-container]');
    const textEl = showMoreBtn.querySelector('[data-show-more-text]');
    
    if (!container) return;
    
    const isExpanded = container.classList.toggle('is-expanded');
    showMoreBtn.classList.toggle('is-expanded', isExpanded);
    
    // Update button text
    if (textEl) {
      textEl.textContent = isExpanded 
        ? getThemeString('showLess', 'Show less')
        : getThemeString('showMore', 'Show more suggestions');
    }
  });
})();
